const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全认证保障',
    description: '通过ISO 27001、等保三级等多项国际国内权威安全认证，多层防护体系全方位保障您的数据和隐私安全。',
  },
  {
    icon: 'ri-rocket-line',
    title: '极速流畅体验',
    description: '全新底层架构重构，启动速度提升40%，内存占用降低25%，即使在旧设备上也能获得丝滑流畅的操作体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多平台兼容',
    description: '全面支持iOS和Android双平台，即将推出HarmonyOS版本。多设备无缝同步，随时随地畅享皇冠App。',
  },
  {
    icon: 'ri-palette-line',
    title: '精致界面设计',
    description: '采用现代化设计语言，图标精致、布局合理。支持深色/浅色主题切换，打造舒适愉悦的视觉体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续版本更新',
    description: '敏捷开发模式，每2-4周推送版本更新。安全补丁24小时内紧急推送，确保应用始终保持最佳状态。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业客服支持',
    description: '7×24小时在线客服团队，2小时内极速响应。提供应用内反馈、邮件、电话等多种支持渠道，问题不隔夜。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择皇冠App
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            六大核心优势，为您打造值得信赖的移动应用平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg p-6 hover:bg-background-50 transition-colors duration-200 group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${feature.icon} text-xl w-5 h-5 flex items-center justify-center text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}